export enum DATE_FORMATS {
  US_SLASHED_FORMAT = 'MM/dd/yyyy',
  US_DASHED_FORMAT = 'MM-dd-yyyy',
}
